import { BaseEvent } from '~/app/tracking/events/base-event';
import { CarPart, EventAction, Package } from '~/app/tracking/feld-m-types';

export class ConfigurationStartAfterEvent extends BaseEvent {
	constructor({
		addedItems,
		removedItems,
		eventName,
	}: {
		addedItems: {
			carParts: CarPart[];
			packages: Package[];
		};
		removedItems: {
			carParts: CarPart[];
			packages: Package[];
		};
		eventName: string;
	}) {
		super({
			eventInfo: {
				eventAction: EventAction.Callback,
				eventName,
			},
			attributes: {
				relatedProducts: {
					addedItems,
					removedItems,
				},
			},
		});
	}
}
